<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20.49 6.63l-8-4.5a1 1 0 00-1 0l-8 4.5A1 1 0 003 7.5v9a1 1 0 00.51.87l8 4.5a1 1 0 001 0l8-4.5a1 1 0 00.49-.87v-9a1 1 0 00-.51-.87zM12 4.15l6.47 3.64-2.69 1.51-6.47-3.64zm0 7.28L5.53 7.79l2.76-1.55 6.47 3.64zM5 8.64l6.5 3.65v7.28L5 15.92zm7.5 10.93v-7.28L19 8.64v7.28z"/></svg>